import React from 'react';

//Generates an arched progress bar, the 0% value will be at 225 degrees (from the top) and 100% will be at 135 degrees. The min, max and actual values are passed in as props. The actual value is used to calculate the percentage of the circle to fill in.

const Gauge = props => {
  const radius = 40;
  const strokeWidth = 8;
  const normalizedRadius = radius - (strokeWidth / 2);
  const circumference = normalizedRadius * 2 * Math.PI;
  const gagueRange = 0.75;

  const clampedActual = Math.min(Math.max(props.actual, props.min), props.max);
  
  //calculate the ratio of the clamped actual value within the min-max range
  const valueRatio = (clampedActual - props.min) / (props.max - props.min);

  const strokeDashoffset = circumference - valueRatio * circumference * gagueRange;
  const fullStrokeDashoffset = circumference - circumference * gagueRange;
  return (
    <div className='gauge-container ratio ratio-1x1'>
      <svg className='gauge' height={radius * 2} width={radius * 2} viewBox={`0 0 ${radius * 2} ${radius * 2}`}>
          <g transform={`rotate(${225-90}, ${radius}, ${radius})`}>

          <circle
            stroke='#ccc'
            fill='transparent'
            strokeWidth={strokeWidth}
            strokeDasharray={`${circumference} ${circumference}`}
            strokeDashoffset={fullStrokeDashoffset}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            strokeLinecap="round"
          />

          <circle
              stroke='#9AEE17'
              fill='transparent'
              strokeWidth={strokeWidth}
              strokeDasharray={`${circumference} ${circumference}`}
              style={{ strokeDashoffset }}
              r={normalizedRadius}
              cx={radius}
              cy={radius}
              strokeLinecap="round"
          />
        </g>
        <text
          x='50%'
          y='50%'
          textAnchor='middle'
          dominantBaseline='central'
          >
          {props.actual? props.actual : ''}
        </text>)}
      </svg>
    </div>
  );
};

export default Gauge;